// extracted by mini-css-extract-plugin
module.exports = {"amount":"amount[Frida]1SqBUbjj"};